var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
var TextModal = /** @class */ (function (_super) {
    __extends(TextModal, _super);
    function TextModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* data */
        _this.showModal = false;
        return _this;
    }
    Object.defineProperty(TextModal.prototype, "curAttrs", {
        // 设置默认属性
        get: function () {
            // 设置属性默认值
            return Object.assign({
                width: this.width,
                center: true,
                title: this.title,
            }, this.$attrs);
        },
        enumerable: false,
        configurable: true
    });
    /* method */
    TextModal.prototype.init = function () {
        this.showModal = true;
    };
    TextModal.prototype.beforeClose = function () {
        this.showModal = false;
        this.$emit('beforeClose');
    };
    __decorate([
        Prop({ type: Boolean, default: false })
    ], TextModal.prototype, "visible", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], TextModal.prototype, "loading", void 0);
    __decorate([
        Prop({ type: String, default: '440px' })
    ], TextModal.prototype, "width", void 0);
    __decorate([
        Prop({ type: String, default: '' })
    ], TextModal.prototype, "title", void 0);
    __decorate([
        Prop({ type: String, default: '' })
    ], TextModal.prototype, "content", void 0);
    TextModal = __decorate([
        Component({
            components: {},
        })
    ], TextModal);
    return TextModal;
}(Vue));
export default TextModal;
